import { NoAccess } from '@mygpt/app';

export default () => {
  return <NoAccess />;
};
